import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { Mixpanel } from "@ionic-native/mixpanel";

import { environment } from "./../environments/environment";

@Injectable()
export class MixpanelService {
    public Auth = null;
    public firebaseProvider: any;

    constructor(private mixpanel: Mixpanel, public platform: Platform) {}

    init() {
        if (!this.platform.is("cordova")) {
            return false;
        }

        var onSuccess = function(success) {
                console.log("Initiated", success);
            },
            onError = function(error) {
                console.log("Initialization Error", error);
            },
            token = environment.mixPanelToken;

        this.mixpanel
            .init(token)
            .then(onSuccess)
            .catch(onError);
    }

    track(eventName, eventProperties?) {
        if (!this.platform.is("cordova")) {
            return false;
        }

        if (typeof eventProperties === "undefined") {
            this.track(eventName);
            return;
        }

        this.track(eventName, eventProperties);
    }
}



// WEBPACK FOOTER //
// ./src/services/mixpanel.service.ts